import connectToContext from './connect';
import type { IAppContext } from './context';
import ContextGuard from './store';

export default ContextGuard;

export { connectToContext, IAppContext };
